<style scoped>

</style>

<template>
  <div style="display: flex;">
    <div style="flex: 1 1 0;">
      <v-text-field
        id="assumptions_forecast_start_input"
        :label="translate('ui_assumptions_forecast_start')"
        hint="YYYY-MM-DD"
        persistent-hint
        required
        outlined
        dense
        append-outer-icon="mdi-calendar"
        @click="onShowDatePicker"
        @click:append-outer="onShowDatePicker"
        :value="$store.state.activeTemplate.data.options.timing.dateStart"
        ref="inputDateStart"
        maxLength="10"
        class="input-date-picker"
        readonly
        background-color="white"
      ></v-text-field>
      <v-menu
        v-model="showDatePicker"
        attach=".input-date-picker"
        bottom
        :close-on-content-click=false
        min-width="290px"
      >
        <v-date-picker
          v-model="periodStart"
          no-title
          scrollable
          @click.native="onDatePickerClick($event)"
          @change="$store.dispatch('saveRemoteTemplate')"
        >
        </v-date-picker>
      </v-menu>
      <div style="display: grid; grid-auto-flow: column; grid-auto-columns: 1fr; gap: 20px; margin-top: 20px;">
        <v-text-field
          id="assumptions_fcst_periods_input"
          :label="translate('ui_assumptions_fcst_periods')"
          v-model="$store.state.activeTemplate.layout.cFcstColCount"
          @change="$store.dispatch('saveRemoteTemplate')"
          required
          outlined
          dense
          background-color="white"
          hide-details
        ></v-text-field>

        <v-select
          id="assumptions_period_type_input"
          :items="periods"
          :label="translate('ui_assumptions_period_type')"
          v-model="$store.state.activeTemplate.data.options.timing.periodicity"
          @change="$store.dispatch('saveRemoteTemplate')"
          outlined
          dense
          background-color="white"
          hide-details
        ></v-select>
      </div>
    </div>
  </div>
</template>

<script>

import Mixin from '../../mixins/mixin';


export default {
  name: 'SectionTimelineDialog',
  components: {},
  mixins: [Mixin],
  props: ['section'],
  data: () => ({
    showDatePicker: false,
  }),
  methods: {
    // previewModelAdjustNav() {
    //   this.previewModel(this.$vuetify.breakpoint);
    // },
    /*
    onDateStartChange(event) {
      const { value } = event.target;
      let { selectionStart } = event.target;
      const arr = value.split('-');

      let YYYY = 'YYYY';
      if (arr[0]) {
        YYYY = arr[0].substring(0, 4).padEnd(4, 'Y');
      }
      let MM = 'MM';
      if (arr[1]) {
        MM = arr[1].substring(0, 2).padEnd(2, 'M');
      }
      let DD = 'DD';
      if (arr[2]) {
        DD = arr[2].substring(0, 2).padEnd(2, 'D');
      }
      const formattedValue = `${YYYY}-${MM}-${DD}`;
      this.$store.dispatch('updateState', {
        path: 'activeTemplate.data.options.timing.dateStart',
        value: formattedValue,
      });
      // eslint-disable-next-line
      // event.input.value = formattedValue;
      let selectionEnd;
      if (event.inputType === 'insertText') {
        if (selectionStart === 4) {
          selectionStart += 1;
        } else if (selectionStart === 7) {
          selectionStart += 1;
        }
        selectionEnd = selectionStart + 1;
      } else if (event.inputType === 'deleteContentBackward') {
        if (selectionStart === 5) {
          selectionStart -= 1;
        } else if (selectionStart === 8) {
          selectionStart -= 1;
        }
        selectionEnd = selectionStart;
      }

      setTimeout(() => {
        this.$refs.inputDateStart.$refs.input.setSelectionRange(selectionStart, selectionEnd);
      }, 10);
    },
    */
    onShowDatePicker() {
      this.showDatePicker = !this.showDatePicker;
      if (this.showDatePicker) {
        setTimeout(() => {
          const datepickerEl = document.querySelector('.v-picker--date').parentElement;
          datepickerEl.style.left = 'inherit';
          datepickerEl.style.right = '0px';
        }, 0);
      }
    },
    /*
    previewModel() {
      this.$store.dispatch('saveRemoteTemplate');
    },
   */
    onDatePickerClick(event) {
      if (event.target.closest('.v-btn') && event.target.closest('.v-date-picker-table--date')) {
        this.showDatePicker = false;
      }
    },
  },
  computed: {
    periodStart: {
      get() {
        let { dateStart } = this.$store.state.activeTemplate.data.options.timing;
        // if invalid format, set to null
        if (!dateStart.match(/\d{4}-\d{2}-\d{2}/)) {
          dateStart = null;
        }
        return dateStart;
      },
      set(value) {
        console.log(value);
        this.$store.commit('updateState', {
          path: 'activeTemplate.data.options.timing.dateStart',
          value,
        });
      },
    },
    periods() {
      return [{
        text: this.translate('month'),
        value: 'month',
      }, {
        text: this.translate('quarter'),
        value: 'quarter',
      }, {
        text: this.translate('year'),
        value: 'year',
      }];
    },
  },
};
</script>
